import { useDispatch, useSelector } from "react-redux";

import { ToggleButton } from "@seneca/senekit";

import { ThemePreference } from "seneca-common/features/user/state/models/UserPreferences";

import { setPreferredTheme } from "features/user";
import { getPreferredTheme } from "features/user/selectors";

import SettingLayout from "./SettingLayout";

const themeOptions = [
  { label: "🔵", value: ThemePreference.BLUE },
  { label: "🟣", value: ThemePreference.PURPLE }
];

type Props = {
  defaultPremiumTheme?: ThemePreference;
};

export default function ThemeSetting({
  defaultPremiumTheme = ThemePreference.PURPLE
}: Props) {
  const dispatch = useDispatch();
  const preferredTheme = useSelector(getPreferredTheme);

  const defaultTheme = preferredTheme || defaultPremiumTheme;

  return (
    <SettingLayout>
      {{
        title: "Theme",
        setting: (
          <ToggleButton
            selectedValue={defaultTheme}
            options={themeOptions}
            onChange={value => dispatch(setPreferredTheme(value))}
          />
        )
      }}
    </SettingLayout>
  );
}
